import { createSlice } from "@reduxjs/toolkit";

const accessDeniedSlice = createSlice({
  name: "accessDenied",
  initialState: { status: false, message: "" },
  reducers: {
    showAccessDenied: (state, action) => {
      state.status = true;
      state.message = action.payload;
    },
    closeAccessDenied: (state) => {
      state.status = false;
      state.message = "";
    },
  },
});

export const { showAccessDenied, closeAccessDenied } = accessDeniedSlice.actions;
export default accessDeniedSlice.reducer;
